import React, { useEffect } from 'react';
import throttle from 'lodash/throttle';

export const CloseOnScroll = ({ children, parentElement, onScroll }:
  {
    parentElement?: HTMLElement;
    children: React.ReactNode;
    onScroll?: () => void;
  }) => {


  useEffect(() => {
    if (!parentElement || !onScroll) {
      return undefined;
    }

    const handleScroll = () => {
      onScroll?.();
    };  
    const scrollableElement = parentElement?.querySelector('.scrollable');
    if (scrollableElement) {
      scrollableElement?.addEventListener('scroll', throttle(handleScroll, 100));
    }
    return () => {
      scrollableElement?.removeEventListener('scroll', handleScroll);
    };
  }, [parentElement, onScroll]);
  return (
    <React.Fragment>
      {children}
    </React.Fragment>
  );
};
